/**
 * 全局方法注册
 */
import Vue from 'vue'
import {Loading, Message} from 'element-ui'
import md5 from 'js-md5'
import {generateButton, generateName} from '@/utils/i18n'
import {parseTime} from '@/utils/format/date'

Vue.prototype.$md5 = md5
Vue.prototype.getWindowClientWH = getWindowClientWH
Vue.prototype.getImgUrl = getImgUrl
Vue.prototype.showMessage = showMessage
Vue.prototype.showLoading = showLoading
Vue.prototype.formatterOrder = formatterOrder
Vue.prototype.formatOssUrl = formatOssUrl

Vue.prototype.generateName = generateName
Vue.prototype.generateButton = generateButton
Vue.prototype.guid = guid
Vue.prototype.parseTime = parseTime
Vue.prototype.parseJson = parseJson
Vue.prototype.objectGetValue = objectGetValue
Vue.prototype.formatExtraResult = formatExtraResult
Vue.prototype.formatShape = formatShape

function getImgUrl(url) {
  return 'api/' + url
}

function showLoading(text, lock, spinner, background) {
  return Loading.service({
    lock: lock || true,
    text: text || '加载中',
    spinner: spinner || 'el-icon-loading',
    background: background || 'rgba(0, 0, 0, 0.7)'
  })
}

function showMessage(message, type) {
  Message({
    message: message,
    type: type
  })
}

// 格式化图片地址
function formatOssUrl(ossUrl) {
  if (!ossUrl) {
    return ossUrl
  }
  const host = window.location.host
  const protocol = window.location.protocol
  // 浏览器域名是否是tcm.ai-tongue.com或tcmtest.ai-tongue.com,如果是，则原url加载；如果不是，则使用浏览器域名替换阿里云域名前缀
  if (host === 'tcm.ai-tongue.com' || host === 'tcmtest.ai-tongue.com') {
    return ossUrl
  } else {
    const regex = new RegExp('^(https?:\\/\\/)([^\\/]+)')
    const urlStr = ossUrl.replace(regex, `$1${host}`)
    if (urlStr.indexOf('http://') === 0 || urlStr.indexOf('https://') === 0) {
      const url = new URL(urlStr)
      url.protocol = protocol
      return url.toString()
    } else {
      return urlStr
    }
  }
}
/*
 * 获取浏览器高宽
 * @returns {{width: number, height: number}}
 */
function getWindowClientWH() {
  let winWidth = 0
  let winHeight = 0
  // 获取窗口宽度
  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if ((document.body) && (document.body.clientWidth)) {
    winWidth = document.body.clientWidth
  }
  // 获取窗口高度
  if (window.innerHeight) {
    winHeight = window.innerHeight
  } else if ((document.body) && (document.body.clientHeight)) {
    winHeight = document.body.clientHeight
  }
  // 通过深入Document内部对body进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    winHeight = document.documentElement.clientHeight
    winWidth = document.documentElement.clientWidth
  }
  return {
    width: winWidth,
    height: winHeight
  }
}

/*
 * 前台获取的排序不是asc和desc,需要转化后转到后台
 * @param order
 * @returns {string}
 */
function formatterOrder(order) {
  let orderBy = 'desc'
  if (order && order.toString().startsWith('asc')) {
    orderBy = 'asc'
  }
  return orderBy
}

/**
 * 获取guid
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 字符串转json
 * @param jsonString
 * @param defaultValue
 * @returns {{}}
 */
export function parseJson(jsonString, defaultValue) {
  let json = defaultValue || {}
  try {
    if (jsonString) {
      json = JSON.parse(jsonString)
    }
  } catch (e) {
    console.log('json转换出错', e)
  }
  return json
}

/**
 * 多层嵌套对象取值
 * @param data
 * @param keysString
 * @returns {undefined|*}
 */
export function objectGetValue(data, keysString) {
  if (!data) {
    return undefined
  }
  if (!keysString) {
    return data
  }

  // [0],[1]... 属性是数组,只可以一层:obj[0]，不可以多层:obj[0][0]
  let reg = /\[[0-9]+\]/g

  let keys = keysString.split('.')

  for (let key of keys) {
    if (key.match(reg)) {
      // 包含数组
      let ArrKey = key.replace(reg, '')
      let ArrIndex = key.replace(ArrKey, '').replace(/\[/, '').replace(/\]/, '')
      if (data[ArrKey] === undefined) {
        return undefined
      } else if (data[ArrKey][ArrIndex] === undefined) {
        return undefined
      } else {
        data = data[ArrKey][ArrIndex]
      }
    } else {
      // 对象
      if (data[key] === undefined) {
        return undefined
      } else {
        data = data[key]
      }
    }
  }
  return data
}

/**
 * 格式化体质名称
 * @param constitutionName
 * @param symptomName
 * @param extraResultJson
 * @returns {string}
 */
export function formatExtraResult(constitutionName, symptomName, extraResultJson) {
  let sn = symptomName ? symptomName.split(/[，,、。；;]/).join('、') : ''
  // 有附加结论展示附加结论
  let res = []
  let mainNameStr = constitutionName
  if (sn) {
    if (mainNameStr) {
      mainNameStr += '（' + sn + '）'
    } else {
      mainNameStr = sn
    }
  }
  res.push(mainNameStr)
  let extraList = []
  try {
    let list = JSON.parse(extraResultJson)
    if (list && list.length > 0) {
      list.forEach(item => {
        let constiName = item.constiName
        let symotomList = ''
        if (item.symptomNameList && item.symptomNameList.length > 0) {
          symotomList = item.symptomNameList.join('、')
          extraList.push(symotomList)
        } else {
          extraList.push(constiName)
        }
      })
    }
  } catch (e) {}
  // 2025-9-23 反馈要把附加病症包起来
  if (extraList) {
    let str = extraList.slice(0, 3).join('、')
    if (str) {
      res.push('兼有（' + str + '）')
    }
  }
  return res.join('、').replace(/证/g, '')
}

export function formatShape(shapeOfTongueNames) {
  if (!shapeOfTongueNames) {
    return ''
  }
  let res = shapeOfTongueNames.split(',').filter(e => !['异常舌形', '肝郁线'].includes(e)).join(',')
  return res || '正常'
}



// WEBPACK FOOTER //
// ./src/utils/global/function/index.js